import React, { Fragment } from 'react';

import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { IconButton, Tooltip } from '@mui/material';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

const renderCodeCell = (params: GridRenderCellParams<any, any, any>, onEditCodeClick: any) => {
  const { field, row, value } = params;

  const editCodeClickHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation(); // Prevent grid row click and other default actions
    onEditCodeClick(row, field);
  };

  return (
    <Fragment>
      <Tooltip
        title={value || 'Missing code'}
        enterDelay={350}
        enterNextDelay={350}
      >
        {value ?
          <div className="data-grid-cell-ellipsis data-grid-cell-pointer">
            {value}
          </div>
          :
          <div className="data-grid-cell-ellipsis data-grid-cell-pointer" style={{opacity: 0.5}}>
            N/A
          </div>
        }
      </Tooltip>

      <Tooltip
        title={'Edit code'}
        enterDelay={350}
        enterNextDelay={350}
      >
        <IconButton
          size="small"
          style={{marginLeft: 'auto'}}
          onClick={editCodeClickHandler}
        >
          <DriveFileRenameOutlineIcon fontSize="medium" color="primary"/>
        </IconButton>
      </Tooltip>
    </Fragment>
  );
}

export const wordMappingColumns = (onEditCodeClick: any): GridColDef[] => [
  { field: 'word', headerName: 'Word', flex: 1 },
  {
    field: 'code_S',
    headerName: 'System Code',
    renderCell: (params) => renderCodeCell(params, onEditCodeClick),
    flex: 1
  },
  {
    field: 'code_SS',
    headerName: 'Sub System Code',
    renderCell: (params) => renderCodeCell(params, onEditCodeClick),
    flex: 1
  },
  {
    field: 'code_COM',
    headerName: 'Component Code',
    renderCell: (params) => renderCodeCell(params, onEditCodeClick),
    flex: 1
  }
];
